import {Component, Input, OnInit} from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import {NavigationExtras, Router} from "@angular/router";
import { NavController } from '@ionic/angular';
import { AccountModel } from 'src/models/accounts/account';
import { Status } from 'src/models/public-collective/appointment/appointment';
import { ArticleModel } from 'src/models/public-collective/content/article/article';

@Component({
  selector: 'app-search-bar-article',
  templateUrl: './search-bar-article.component.html',
  styleUrls: ['./search-bar-article.component.scss'],
})
export class SearchBarArticleComponent implements OnInit {
  @Input() placeholder:string;
  constructor(private route:Router, private firestore: AngularFirestore,
    private navCtrl: NavController
    ) { }
  ngOnInit() {}
  isItemAvailable = false;
  items = [] as {obj: ArticleModel, ref: string}[];

  initializeItems(val: string){
    //this.items = ["Ram","gopi", "dravid"];
    this.items = [];
    this.firestore.collection<ArticleModel>('articles', ref=> ref.where('status','==',Status.approved).orderBy('title').startAt(val).endAt(val + '\uf8ff')).get().toPromise().then(res => {
      res.docs.forEach((item) => {
        this.items.push({obj: item.data() as ArticleModel, ref: item.id});
        console.log(this.items);
      })
    }).catch(err => {
      console.log(err);
    });
  }

  getItems(ev: any) {
    // Reset items back to all of the items
    

    // set val to the value of the searchbar
    const val:string = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() !== '' && val.length >=3) {
      this.isItemAvailable = true;
      this.initializeItems(val);
/*       this.items = this.items.filter((item) => {
        console.log((item.obj.title.toLowerCase().indexOf(val.toLowerCase()) > -1));
        
        return (item.obj.title.toLowerCase().indexOf(val.toLowerCase()) > -1);
      }) */
      console.log(this.items);
      
    } else {
      this.isItemAvailable = false;
    }
  }

  articleDetail(articleRef: string){
    let navigationExtras: NavigationExtras = {
      state: {
          articleId: articleRef
      }
  };
    this.navCtrl.navigateForward(['article-detail'], navigationExtras);
  }  
}

